<template>
  <div v-if="estAffichee">
    <div
      class="d-flex"
      :class="classeLigne"
    >
      <div
        v-if="estMobile"
        class="d-flex flex-column justify-center mr-auto ligne-mobile"
      >
        <div
          class="intro"
          :class="classeLibelle"
        >
          {{ libelle }}
          <v-icon
            v-if="hasSousPostes"
            size="24"
            color="secondary"
            @click="basculerDetail"
          >
            {{ estDeplie ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </div>
        <div
          class="titre-h4"
          :class="classeTexte"
        >
          {{ valeurAffichee }} {{ libelleUnite }}
        </div>
      </div>
      <div
        v-if="estMobile && hasEvolution"
        class="texte align-self-center element element-mobile"
        :class="classeTexteSecondaire"
      >
        <BaseEvolutionWithInfo
          v-if="evolution != null"
          :evolution-value="evolution"
          :values="valeursEvolution"
          :unite="libelleUnite"
          :hausse-favorable="hausseFavorable"
        />
        <span v-else>-</span>
      </div>
      <div
        v-if="!estMobile"
        class="intro align-self-center mr-auto"
        :class="classeLibelle"
      >
        {{ libelle }}
        <v-icon
          v-if="hasSousPostes"
          size="24"
          color="secondary"
          @click="basculerDetail"
        >
          {{ estDeplie ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>

      <div
        v-if="!estMobile"
        class="titre-h4 align-self-center element"
        :class="classeTexte"
      >
        {{ valeurAffichee }}<span v-if="estUnTotal"> {{ libelleUnite }}</span>
      </div>

      <div
        v-if="!estMobile && hasEvolution"
        class="texte align-self-center element"
        :class="classeTexteSecondaire"
      >
        <BaseEvolutionWithInfo
          v-if="evolution != null"
          :evolution-value="evolution"
          :values="valeursEvolution"
          :unite="libelleUnite"
          :hausse-favorable="hausseFavorable"
        />
        <span v-else>-</span>
      </div>

      <div
        class="texte align-self-center element colonne-groupe"
        :class="[classeTexteSecondaire, estMobile ? 'element-mobile' : 'pl-9']"
      >
        <template v-if="!estUnTotal">
          <v-tooltip
            v-if="estGroupeInsuffisant"
            max-width="240"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <img
                class="align-self-center"
                :src="pictoGroupe"
                :alt="libelle"
                v-bind="attrs"
                v-on="on"
              >
            </template>
            <span>{{ MESSAGE_GROUPE_INSUFFISANT }}</span>
          </v-tooltip>
          <img
            v-else
            class="align-self-center"
            :src="pictoGroupe"
            :alt="libelle"
          >
        </template>
      </div>
    </div>

    <div v-if="hasSousPostes && estDeplie">
      <LigneRestitution
        v-for="sousPoste in sousPostes"
        :key="sousPoste.cle"
        est-un-sous-poste
        :libelle="sousPoste.libelle"
        :champ="sousPoste.champ"
        :evolution="sousPoste.evolution"
        :valeurs-evolution="sousPoste.valeursEvolution"
        :champ-groupe="sousPoste.champGroupe"
        :unite="unite"
        :has-evolution="hasEvolution"
        :hausse-favorable="hausseFavorable"
      />
    </div>

    <v-divider v-if="!estUnTotal && !estDeplieAvecSousPostes" />
  </div>
</template>
<script>
import {
  valeurSelonUnite, valeurGroupeSelonUnite, repartitionSelonUnite,
  arrondir, doitAfficherLigne, positionDansGroupe,
  UNITE_TONNE, UNITE_HECTARE, GROUPE_SUPERIEUR, GROUPE_INFERIEUR, GROUPE_INSUFFISANT, GROUPE_INCONNU
} from '@/utils/restitution'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'

const MESSAGE_GROUPE_INSUFFISANT = 'Groupe insuffisant pour proposer une comparaison'

export default {
  name: 'LigneRestitution',
  components: { BaseEvolutionWithInfo },
  props: {
    libelle: {
      type: String,
      required: true
    },
    champ: {
      type: Object,
      default: null
    },
    evolution: {
      type: Number,
      default: null
    },
    valeursEvolution: {
      type: Object,
      default: () => ({})
    },
    hausseFavorable: {
      type: Boolean,
      default: true
    },
    champGroupe: {
      type: Object,
      default: undefined
    },
    unite: {
      type: String,
      default: UNITE_TONNE
    },
    hasEvolution: {
      type: Boolean,
      default: false
    },
    sousPostes: {
      type: Array,
      default: () => []
    },
    estUnTotal: {
      type: Boolean,
      default: false
    },
    estUnSousPoste: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      estDeplie: false,
      MESSAGE_GROUPE_INSUFFISANT
    }
  },
  computed: {
    estMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    libelleUnite () {
      return this.unite === UNITE_HECTARE ? '€/ha' : '€/t'
    },
    valeur () {
      return valeurSelonUnite(this.champ, this.unite)
    },
    repartitionGroupe () {
      return repartitionSelonUnite(this.champGroupe, this.unite)
    },
    valeurGroupe () {
      return valeurGroupeSelonUnite(this.champGroupe, this.unite)
    },
    estAffichee () {
      return doitAfficherLigne(this.valeur, this.valeurGroupe)
    },
    valeurAffichee () {
      const arrondie = arrondir(this.valeur)
      return arrondie != null ? arrondie : '-'
    },
    position () {
      return positionDansGroupe(this.repartitionGroupe)
    },
    pictoGroupe () {
      if (this.position === GROUPE_SUPERIEUR) {
        return require('@/assets/icon-groupe-positif.svg')
      }
      if (this.position === GROUPE_INFERIEUR) {
        return require('@/assets/icon-groupe-negatif.svg')
      }
      return require('@/assets/icon-groupe-neutre.svg')
    },
    hasSousPostes () {
      return this.sousPostes.length > 0
    },
    estDeplieAvecSousPostes () {
      return this.hasSousPostes && this.estDeplie
    },
    classeLibelle () {
      if (this.estUnTotal) {
        return 'white--text font-weight-bold'
      }
      return this.estUnSousPoste ? 'texte-gris-fonce' : 'secondary--text'
    },
    classeTexte () {
      if (this.estUnTotal) {
        return 'white--text'
      }
      return this.estUnSousPoste ? 'texte-gris-fonce' : 'secondary--text'
    },
    classeTexteSecondaire () {
      return this.estUnTotal ? 'white--text' : 'texte-gris-fonce'
    },
    classeLigne () {
      if (this.estUnTotal) {
        return 'total'
      }
      return this.estUnSousPoste ? 'ligne-secondaire' : 'ligne-principale'
    },
    estGroupeInsuffisant () {
      return this.position === GROUPE_INSUFFISANT || this.position === GROUPE_INCONNU
    }
  },
  methods: {
    basculerDetail () {
      this.estDeplie = !this.estDeplie
    },
    deplier () {
      this.estDeplie = true
    },
    replier () {
      this.estDeplie = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-icon--link:focus::after {
  opacity: 0;
}

.ligne-principale {
  width: 100%;
  box-sizing: border-box;
  height: 56px;
  padding-left: 16px;

  .element {
    width: 112px;
    height: 25px;
  }
}

.ligne-secondaire {
  background-color: #F1F2F5;
  width: 100%;
  box-sizing: border-box;
  height: 56px;
  padding-left: 24px;

  .element {
    width: 112px;
    height: 25px;
  }
}

.total {
  border-radius: 8px;
  background-color: var(--branche);
  width: 100%;
  box-sizing: border-box;
  height: 64px;
  padding-left: 16px;
  padding-bottom: 6px;

  .element {
    width: 112px;
    height: 25px;
  }
}

@media (max-width: 960px) {
  .ligne-principale,
  .ligne-secondaire,
  .total {
    width: 100%;
    height: auto;
    min-height: 56px;
    padding-left: 8px;
    padding-right: 8px;

    .element {
      width: auto;
      height: auto;
    }
  }

  .ligne-secondaire {
    padding-left: 16px;
  }

  .ligne-mobile {
    min-width: 0;
    padding: 6px 0;
  }

  .element-mobile {
    flex: 0 0 auto;
    padding-left: 8px;
  }

  .colonne-groupe {
    min-width: 32px;
  }
}
</style>
